import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@environment';
import { GtmService } from '@core/services/analytics/gtm.service';
import { PlatformService } from '../util/platform.service';

@Injectable({
    providedIn: 'root'
})
export class GoogleMapService {
    private _isMapLoaded = false;
    private _libraries = new Array('places', 'geometry');
    private _googleMapApiUrl = 'https://maps.googleapis.com/maps/api/js?v=quarterly';
    private callbackFn: Function = () => {}; // this function needs to be run after loading google map

    onMapLoad$ = new BehaviorSubject<boolean>(false);

    constructor(
        private gtmService: GtmService,
        private platformService: PlatformService
    ) {
        if (this.platformService.isBrowser()) {
            (window as any).googleMapCallBack = this.googleMapCallBack.bind(this);
        }
    }

    private _getMapUrl(): string {
        return `${this._googleMapApiUrl}&libraries=${this._libraries.join(',')}&key=${environment.googleMapKey}&loading=async&callback=googleMapCallBack`;
    }

    googleMapCallBack() {
        if (this.callbackFn) this.callbackFn();
        this._isMapLoaded = true;
        this.onMapLoad$.next(true);
    }

    loadGoogleMap(callBack: Function = () => {}): Promise<boolean> {
        this.callbackFn = callBack;

        if (this._isMapLoaded) {
            this.googleMapCallBack();
            return Promise.resolve(true);
        }

        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = this._getMapUrl();
            script.onerror = () => {
                this.gtmService.logWebAnalyticsEvent('script_failure', 'Failed To Load GoogleMap');
                reject(false);
            };

            script.onload = () => resolve(true);
            const t = document.getElementsByTagName('script')[0];
            t.parentNode.insertBefore(script, t);
        });
    }

    getMapStyles() {
        return [
            {
                featureType: 'poi',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'poi',
                elementType: 'labels.icon',
                stylers: [
                    {
                        color: '#ABB0BA'
                    }
                ]
            },
            {
                featureType: 'poi',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#ABB0BA'
                    }
                ]
            },
            {
                featureType: 'road',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#FFFFFF'
                    }
                ]
            },
            {
                featureType: 'road',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'road',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#ABB0BA'
                    }
                ]
            },
            {
                featureType: 'road',
                elementType: 'labels.text.stroke',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            }
        ];
    }
}
